/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDivide = createReactComponent("outline", "divide", "IconDivide", [["circle", { "cx": "12", "cy": "6", "r": "1", "fill": "currentColor", "key": "svg-0" }], ["circle", { "cx": "12", "cy": "18", "r": "1", "fill": "currentColor", "key": "svg-1" }], ["path", { "d": "M5 12l14 0", "key": "svg-2" }]]);

export { IconDivide as default };
//# sourceMappingURL=IconDivide.mjs.map
